import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { SupersetAnalyticsDashboards } from './__generated__/SupersetAnalyticsDashboards';

export const SUPERSET_ANALYTICS_DASHBOARDS = gql`
  query SupersetAnalyticsDashboards {
    analytics {
      dashboards {
        id
        title
        key
      }
    }
  }
`;

const useSupersetAnalyticsDashboards = () => {
  const { data, loading, error } = useQuery<SupersetAnalyticsDashboards>(
    SUPERSET_ANALYTICS_DASHBOARDS,
    {
      errorPolicy: 'all',
      returnPartialData: false,
    },
  );

  return { data, loading, error };
};

export default useSupersetAnalyticsDashboards;
